// JSON-LD Structured Data for SEO

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SecondChance.dev',
  url: 'https://secondchance.dev',
  logo: 'https://secondchance.dev/logo.png',
  description: 'A bias-free hiring platform connecting overlooked tech talent with forward-thinking employers.',
  sameAs: [
    'https://www.linkedin.com/company/secondchancedev',
    'https://twitter.com/secondchancedev',
    'https://github.com/secondchancedev',
    'https://discord.gg/secondchancedev'
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'info@secondchance.dev',
    contactType: 'customer service',
    availableLanguage: 'English'
  }
}

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'SecondChance.dev',
  url: 'https://secondchance.dev',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://secondchance.dev/search?q={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
}

export function createArticleSchema(article) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Organization',
      name: 'SecondChance.dev'
    },
    publisher: {
      '@type': 'Organization',
      name: 'SecondChance.dev',
      logo: {
        '@type': 'ImageObject',
        url: 'https://secondchance.dev/logo.png'
      }
    },
    datePublished: article.publishDate,
    dateModified: article.publishDate,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://secondchance.dev/blog/${article.slug}`
    }
  }
}

export function createJobPostingSchema(job) {
  return {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: job.title,
    description: job.description,
    datePosted: job.datePosted,
    validThrough: job.validThrough,
    employmentType: job.employmentType || 'FULL_TIME',
    hiringOrganization: {
      '@type': 'Organization',
      name: job.companyName,
      sameAs: job.companyUrl || ''
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: job.city || 'Remote',
        addressRegion: job.state || '',
        addressCountry: job.country || 'US'
      }
    },
    baseSalary: job.salary ? {
      '@type': 'MonetaryAmount',
      currency: 'USD',
      value: {
        '@type': 'QuantitativeValue',
        minValue: job.salary.min,
        maxValue: job.salary.max,
        unitText: 'YEAR'
      }
    } : undefined
  }
}

export function createFAQSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer.replace(/<[^>]*>/g, '') // Remove HTML tags
      }
    }))
  }
}

export function injectStructuredData(schema) {
  if (typeof document === 'undefined') return
  
  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.text = JSON.stringify(schema)
  document.head.appendChild(script)
  
  return () => {
    if (script.parentNode) {
      script.parentNode.removeChild(script)
    }
  }
}